import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocationRegistration } from "src/app/models/location-registration.model";
import { ApiKeyGeneratorService } from "../../api-key-generator.service";
import { ApiService } from "../../api.service";
import { BaseService } from "../base.service";

@Injectable({
    providedIn: 'root'
  })
  export class LocationRegistrationService {

    private apiUrl: string;

    constructor (
      private api: ApiService,
      protected http: HttpClient,
      private _apiKeyService: ApiKeyGeneratorService
    ) {
      this.apiUrl = `${this.api.getRootApiUrl()}/shared/user-registration/location-registration`;
    }

    getLocationInfo(locationReference: string) {
      return this.http.get<LocationRegistration>(`${this.apiUrl}?locationReference=${locationReference}`, {
        headers: this._apiKeyService.getApiKeyHeaders()
      });
    }
}
